import type { ICustomerPayment } from "@/data/model/CustomerPayment";
import { Signal, TypedSignal } from "@/data/util/Signal";

import { ViewTransition } from "@/app/controller/BaseController";
import { BaseController } from "@/app/controller/BaseController";

export interface IPaymentReceiptControllerTransitionData {
    payment: ICustomerPayment;
    transition: ViewTransition;
    onGoBack?: { () };
}

export class PaymentReceiptController extends BaseController {
    public onContinue?: { () };
    public onGoBack?: { () };

    // controller to view events
    static onShown = new TypedSignal<ICustomerPayment>();
    static onHidden = new Signal();

    // view to controller events
    static onGoBack = new Signal();
    static onViewUnmounted = new Signal();

    constructor() {
        super("payment-receipt");
        PaymentReceiptController.onGoBack.add(this.goBack, this);
    }

    protected onBecomeVisible(data: IPaymentReceiptControllerTransitionData) {
        PaymentReceiptController.onShown.dispatch(data.payment);
    }

    protected onBecomeInvisible() {
        PaymentReceiptController.onHidden.dispatch();
    }

    protected goBack() {
        if (this.onGoBack) {
            this.onGoBack();
        }
    }

    protected continue() {
        if (this.onContinue) {
            this.onContinue();
        }
    }
}
